import React from 'react';

import CollectRender from '../../collect/CollectRender';

const CollectViewExhibitorScreen = props => {
    const {item} = props;
    let collect;

    if (item.is_exhibitor) {
        collect = {
            objectType: 'exhibitor',
            objectId: item.id,
        };
    }

    if (!collect) return null;

    return <CollectRender {...collect} />;
};

export default CollectViewExhibitorScreen;
